import { render, staticRenderFns } from "./TaxReturnTableInput.vue?vue&type=template&id=894a7794&scoped=true&"
import script from "./TaxReturnTableInput.vue?vue&type=script&lang=js&"
export * from "./TaxReturnTableInput.vue?vue&type=script&lang=js&"
import style0 from "./TaxReturnTableInput.vue?vue&type=style&index=0&id=894a7794&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894a7794",
  null
  
)

export default component.exports